const APP_API_URL = process.env.REACT_APP_API_BASE_URL;

export const getFullImageUrl = (imagePath) => {
  if (!imagePath) return "";
  if (imagePath.startsWith("http")) return imagePath; // already full URL
  
  return `${APP_API_URL}${imagePath}`;
};